import { createClient } from '@/utils/supabase/client';

// HACK: Define types locally to avoid import from a deleted file
type Plan = any;
type PlanInsert = any;

interface PlanResponse {
  data: Plan[] | null;
  error: any;
}

interface SinglePlanResponse {
  data: Plan | null;
  error: any;
}

export const planService = {
  async insert(planData: PlanInsert): Promise<SinglePlanResponse> {
    const supabase = createClient();
    try {
      if (!('user_id' in planData) || !planData.user_id) {
        try {
          const { data: userData } = await supabase.auth.getUser();
          const user = (userData as any)?.user;
          if (user?.id) {
            (planData as any).user_id = user.id;
          }
        } catch (err) {
          // ignore
        }
      }

      const { data, error } = await supabase
        .from('plans')
        .insert(planData)
        .select()
        .single();
      
      return { data, error };
    } catch (error) {
      return { data: null, error };
    }
  },

  async fetchByUserId(userId: string): Promise<PlanResponse> {
    const supabase = createClient();
    try {
      const { data, error } = await supabase
        .from('plans')
        .select('*')
        .eq('user_id', userId)
        .order('created_at', { ascending: false });
      
      return { data, error };
    } catch (error) {
      return { data: null, error };
    }
  },

  async fetchAll(): Promise<PlanResponse> {
    const supabase = createClient();
    try {
      const { data, error } = await supabase
        .from('plans')
        .select('*')
        .order('created_at', { ascending: false });
      
      return { data, error };
    } catch (error) {
      return { data: null, error };
    }
  },

  async fetchById(planId: string): Promise<SinglePlanResponse> {
    const supabase = createClient();
    try {
      const { data, error } = await supabase
        .from('plans')
        .select('*')
        .eq('id', planId)
        .single();
      
      return { data, error };
    } catch (error) {
      return { data: null, error };
    }
  },

  async update(planId: string, updates: Partial<Plan>): Promise<SinglePlanResponse> {
    const supabase = createClient();
    try {
      const { data, error } = await supabase
        .from('plans')
        .update(updates)
        .eq('id', planId)
        .select()
        .single();
      
      return { data, error };
    } catch (error) {
      return { data: null, error };
    }
  },

  async delete(planId: string): Promise<{ error: any }> {
    const supabase = createClient();
    try {
      const { error } = await supabase
        .from('plans')
        .delete()
        .eq('id', planId);
      
      return { error };
    } catch (error) {
      return { error };
    }
  },

  async create(planData: PlanInsert): Promise<SinglePlanResponse> {
    return this.insert(planData);
  },

  async getAll(userId: string): Promise<PlanResponse> {
    if (!userId) {
      return { data: [], error: { message: 'User ID is required' } };
    }
    return this.fetchByUserId(userId);
  }
};